import laurynPic from "@/public/images/artists/lauryn.png";
import { Artist } from "@/types/types";

export const lauryn = {
  id: "160",
  name: "Lauryn",
  image: laurynPic,
  description: `Lauryn's voice is rich and full-bodied, with a warm, textured timbre that balances power and emotional depth. She displays exceptional control, moving effortlessly between soulful lows and agile highs, while her precise, fluid vocal runs add subtle complexity to each phrase.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Flauryn-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Dance", "Soul"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
